// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8784 ? "be74e82d" : chunkId) + "." + {"3166":"ac555a9f30dad036","8784":"115418210c15e174"}[chunkId] + ".js";
};